/**
 * Enum for language codes.
 */
export const LanguageCode = {
    /** Arabic */
    AR: 'ar',
    /** English */
    EN: 'en',
    /** Estonian */
    ET: 'et',
    /** Spanish */
    ES: 'es',
    /** French */
    FR: 'fr',
    /** Hebrew */
    HE: 'he',
    /** Lithuanian */
    LT: 'lt',
    /** Latvian */
    LV: 'lv',
    /** Malay */
    MS: 'ms',
    /** Russian */
    RU: 'ru',
    /** Thai */
    TH: 'th',
};
export const isLanguageCode = (x) => Object.values(LanguageCode).includes(x);
